import { Pages } from '@src/Pages';
import * as mqtt_instance from '../mqtt_instance';
import { createDriveInformationModal } from './driveInformationModal.js';
import { createEstopModal } from './estopModal';
import { EstopStateEnum } from './estopStateEnum';
import { remoteSupportServices } from '@src/RemoteSupportServices';

let gLastState;
let gOnEstopStatusChanged = onEstopStateChanged;
const estopModal = createEstopModal();
const driveInformationModal = createDriveInformationModal();

export function listenToEstop (navigate) {
  estopModal.setNavigateFunction(navigate);
  driveInformationModal.setNavigateFunction(navigate);

  mqtt_instance.getClient(function (client) {
    client.subscribe('execution-engine/estop', /execution-engine\/estop/, function (_pTopic, pMessage) {
      let lJson;
      try {
        lJson = JSON.parse(pMessage);
      }
      catch (e) {
        console.error(e);
        return;
      }

      if (!lJson) {
        return;
      }

      _onDriveInformationChange(gLastState, lJson);

      if (gLastState && gLastState.estop === lJson.estop) {
        return; // Nothing has changed.
      }

      gLastState = lJson;

      switch (lJson.estop) {
        case EstopStateEnum.Triggered:
        case EstopStateEnum.Released:
        case EstopStateEnum.Unknown: {
          remoteSupportServices.updateEstopState(lJson.estop);
          gOnEstopStatusChanged(lJson.estop);
          break;
        }
        default: {
          console.error('Unhandled estop payload: ', lJson);
          break;
        }
      }
    });
  });
}

function onEstopStateChanged (pEstopState) {
  const lIsOnRemoteSupportPage = window.location.pathname === Pages.REMOTE_SUPPORT;
  const lIsInSupportCall = remoteSupportServices.isActive();

  if (lIsOnRemoteSupportPage) {
    estopModal.hideModal();
    return;
  }

  if (pEstopState === EstopStateEnum.Released) {
    estopModal.hideModal();
    return;
  }

  estopModal.showModal(pEstopState, lIsInSupportCall);
}

function _onDriveInformationChange (pLastState, pCurrentState) {
  // We check if lastState exists because we do not want the modal to show up when the user opens the page for the
  // first time when the state is estop -> released , smartdrives -> ready.
  if (pLastState && window.location.pathname !== Pages.CONFIG_CHECKER) {
    if (pCurrentState.estop !== EstopStateEnum.Triggered) {
      driveInformationModal.showDriveInformationModal(pCurrentState);
    }
    else if (pCurrentState.estop === EstopStateEnum.Triggered) {
      driveInformationModal.closeDriveInformationModal();
    }
  }
}

// Note(AJ) Exclusively used only by config checker
export function reconnectEstopModalCallback () {
  gOnEstopStatusChanged = onEstopStateChanged;
}

// Note(AJ) Exclusively used only by config checker
export function replaceEstopCallback (pNewOnEstopStatusChanged) {
  gOnEstopStatusChanged = (_pEstopState, _pAreSmartDrivesReady) => { console.warn('no callback is attached to estop state'); };
  if (pNewOnEstopStatusChanged) {
    gOnEstopStatusChanged = pNewOnEstopStatusChanged;
  }
}

export function refreshEstopModal () {
  if (gLastState) {
    gOnEstopStatusChanged(gLastState.estop);
  }
}

export function getLastEstopState () {
  return gLastState;
}
